<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		{{title}}
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
	</div>
</div>

<div id="{{objectIdForCollapsingWidget}}" *ngIf="!toggled" [hidden]="toggled" class="jmWidgetPadding">
	<div class="w-100" style="height:6%">
		<div class="jmPageTitle" style="padding-bottom: 10px;">
			{{title}}
			<span>
				<i class="jmInfoCircle" style="vertical-align:middle" (click)="displayInfoWrapper('Students Receiving Federal Loans','The share of undergraduate students who borrowed federal loans to help pay for college. Excludes Parent PLUS loans.', 'financialAid')"></i>
			</span>
			<div (click)="toggleCollapse()"  *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="right: 0px; margin-top:10px;"></div>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-hidden-md">&nbsp;</div>
	</div>
	<div class="row">
		<div [ngClass]="(lgView===true)?'col-6':'col-12'">
			<div class="row">
				<div class="col-5 offset-1 pie-wrapper">
					<figure>
						<svg id="financePie{{size}}" viewBox="-1 -1 2 2" [ngStyle]="pieStyle"></svg>
					</figure>
				</div>
				<div class="col-6 pie-legend" style="height:150px; padding-right:10px;">
					<table style="height:100%; margin-left:10px;">
					<tr style="height:50%;"><td style="color:#56dcc4; padding-right:15px;">{{data.StudentsReceivingFederalLoansPcnt}}%</td>
						<td class="pie-label">Students Receiving Federal Loans</td>
					</tr>
					<tr><td style="color:#00adf2; margin-right:15px;">{{data.StudentsNotReceivingFederalLoansPcnt}}%</td>
						<td class="pie-label">Not Receiving Student Loans</td>
					</tr>
					</table>
				</div>
			</div>
		</div>
		<div [ngClass]="(lgView===true)?'col-6':'col-12'" style="text-align:center;">
			<div class="spacer-bottom">
				<span style="font-weight:bold;" class="section-heading ">Students Paying Down Debt</span>
				<i class="jmInfoCircle" (click)="displayInfoWrapper('Students Paying Down Debt','The share of students who have repaid at least $1 of the principal balance on their federal loans within 3 years of leaving school.', 'payingDebt')"></i>
			</div>
			<figure class="meter debt-meter">
				<picc-meter [attr.max]="'100'" [attr.average]="data.StudentsPayingDownTheirDebt" [attr.national-average]="data.PayingDownNationalAverage">
					<div class="picc-meter-bar" [ngStyle]="{'height':data.StudentsPayingDownTheirDebtPcnt+'%'}"></div>
					<div class="picc-meter-line" [ngStyle]="{'bottom':data.PayingDownNationalAveragePcnt+'%'}"><span class="label">{{data.PayingDownNationalAveragePcnt}}%</span></div>
				</picc-meter>
				<figcaption><span *ngIf="data.StudentsPayingDownTheirDebtPcnt>0">{{data.StudentsPayingDownTheirDebtPcnt}}%</span><span *ngIf="data.StudentsPayingDownTheirDebt==0">Data not available</span></figcaption>
			</figure>
			<div>---- National Average</div>
		</div>
	</div>
	<div class="row" style="margin-top:10px;margin-bottom:10px;">
		<div [ngClass]="(lgView===true)?'col-5 offset-1 spacer-top':'col-sm-6 offset-1 col-11 spacer-top'">
			<div>Typical Total Debt
				<i class="jmInfoCircle" (click)="displayInfoWrapper('Typical Total Debt','The median federal debt of undergraduate borrowers who completed. This figure includes only federal loans; it excludes private student loans and Parent PLUS loans.', 'totalDebt')"></i>
			</div>
			<div style="color:#56dcc4;">${{appUtility.toCommaNumber(data.TypicalTotalDebt)}}</div>
		</div>
		<div [ngClass]="(lgView===true)?'col-5 offset-1 spacer-top':'col-sm-6 offset-1 col-11 spacer-top'">
			<div>Typical Monthly Loan Payment
				<i class="jmInfoCircle" (click)="displayInfoWrapper('Typical Monthly Loan Payment','The median monthly load payment for students who completed, if it were repaid over 10 years at a 4.29 percent interest rate.', 'monthlyLoan')"></i>
			</div>
			<div style="color:#56dcc4;">${{appUtility.toCommaNumber(data.TypicalMonthlyLoanPayment)}}/mo</div>
		</div>
	</div>
</div>
